export enum CaptionSourceEnum {
  HTTP = 0,
  TCP = 1,
  BLOB = 2,
  ASR = 3,
  AccessLOOP = 4,
  StreamText = 5,
}

export type CaptionSource =
  | CaptionSourceEnum.HTTP
  | CaptionSourceEnum.TCP
  | CaptionSourceEnum.BLOB
  | CaptionSourceEnum.ASR
  | CaptionSourceEnum.AccessLOOP
  | CaptionSourceEnum.StreamText;
